export const environment = {
  production: true,
  api: 'https://api-sso.amica.pl/panel',
  upload: 'https://api-sso.amica.pl/uploads',
  recaptchaV3SiteKey: '6LfI-RMiAAAAAJ71UXwAJxTYJjE1NYO7cAUjBqm-',
};
